import { observable, action, configure } from 'mobx';

import { User } from '@types/User.t';

interface ILoginStore {
  user: User,
  isLoading: boolean
}

configure({ enforceActions: 'observed' });

class LoginStore implements ILoginStore {
  @observable user: User = {};

  @observable isLoading = false;

  @action.bound
  handleChange ({ target: { name, value } }: { target: HTMLInputElement }) {
    this.user[name] = value;
  }
}

export default new LoginStore();
